import React, {Fragment} from 'react';
import ClassNames from 'classnames';
import styled from 'styled-components'

import Typography from 'Atoms/Typography'
import LayerColorFinder from 'Utilities/LayerColorFinder'

import styles from './Textbox.module.scss'
import InlineSpinner from '../../InlineSpinner/InlineSpinner';
const Textbox = (
    {
        list,
        id,
        label,
        type,
        intent,
        brand,
        fill,
        isWaiting,
        hideSpinner,
        validationErrorMessages,
        ...props
    }
) => {
    type = type || "text"

    const classNames = ClassNames(
        styles.textbox,
        fill && styles.fill
    )

    const borderColor = intent || brand ? LayerColorFinder(undefined, undefined, brand, intent) : LayerColorFinder(2)

    return (
        <Fragment>     
            {isWaiting ?  
            <div className={styles.spinnerWrapper}>
                <InlineSpinner brand={brand} intent={intent}/>
            </div>
            :
            <>     
                <Label id={id} text={label} />
                <Typography intent={'negative'} >
                    {validationErrorMessages?.map((m) => (<div>{m}</div>))}
                </Typography>
                <div className={classNames}>
                    <StyledInput className={hideSpinner ? styles.hideSpinner : false} list={list} type={type} id={id} name={id} borderColor={borderColor} {...props}/>
                </div>
            </>}
        </Fragment>
    )
}

const Label = ({text, id}) => {
    if(!text){
        return false
    }

    return (
        <Typography as={'label'} htmlFor={id}>{text}</Typography>
    )
}


const StyledInput = styled.input`
    border-color: ${props => props.borderColor};
`

export default Textbox;